export default __webpack_public_path__ + "static/media/investor-8.0519c307.png";